/**
 * EllaAdvisorConsole.tsx
 * Combines chat, insights, and quick actions.
 */

import EllaChatWidget from '@/components/compliance/EllaChatWidget';
import RiskHealthDashboard from '@/components/compliance/RiskHealthDashboard';
import GovernanceDeadlines from '@/components/compliance/GovernanceDeadlines';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

export default function EllaAdvisorConsole({ companyId }: { companyId: string }) {
  return (
    <div className="space-y-6 p-4 max-w-6xl mx-auto">
      <EllaChatWidget companyId={companyId} />
      <Card className="border-border bg-card">
        <CardHeader>
          <CardTitle>Quick Insights</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Ella analyses live risk, deadlines, and triggers to answer questions like:
            <ul className="list-disc pl-6 mt-1">
              <li>"Why is our compliance score dropping?"</li>
              <li>"Which jurisdictions are trending risky?"</li>
              <li>"Generate all filings due next week."</li>
            </ul>
          </p>
        </CardContent>
      </Card>
      <RiskHealthDashboard />
      <GovernanceDeadlines companyId={companyId} />
    </div>
  );
}
